import { CvUploader } from "PFApp/profiles/common/cv_uploader";
import { Modal } from "PFComponents/modal";
import { useTranslation } from "react-i18next";

type UploadCvModalProps = {
  onClose: VoidFunction;
};

export const UploadCvModal = ({ onClose }: UploadCvModalProps) => {
  const { t } = useTranslation("profiles");

  return (
    <Modal
      title={t("show.parts.uploadNewCV")}
      onClose={onClose}
      showOKButton={false}
      showCancelButton={false}
      size="lg"
    >
      <CvUploader />
    </Modal>
  );
};
